import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import NoPermissionIcon from '../../assets/permission-lock.svg';
import styles from './NoPermission.module.css';

const Link = () => (
    <a target="_blank" className={styles.link} href="https://apps.appf.re/oc/doc" rel="noreferrer">
        Learn more about Octo Component Management
    </a>
);

export default () => (
    <div className={styles.container}>
        <EmptyState
            header="You don't have access to this page"
            description="Ask project admin for permission to view Octo Component Management."
            tertiaryAction={<Link />}
            imageHeight={150}
            imageUrl={NoPermissionIcon}
        />
    </div>
);
